import React, { useState } from "react";
import styles from "./RangeFilterComponent.module.scss";
import { rangeFilterComponentProps } from "../../../category/StoreFrontCategory";
import { toast } from "react-toastify";

type Props = {
	x: rangeFilterComponentProps
	onFilterChange: (queryParams: string) => void
};



const RangeFilterComponent: React.FC<Props> = (props: Props) => {
	const [ filter, setFilter ] = useState<string[]>([]);

	const [ minValueString , setMinValueString ] = useState('');
	const [ maxValueString, setMaxValueString ] = useState('');

	// Function to handle filter changes
	const onComponentFilterChange = () => {
		const minValue = parseFloat(minValueString)
		const maxValue = parseFloat(maxValueString)

		if (Number.isNaN(minValue) && Number.isNaN(maxValue) ) {
			props.onFilterChange('');
			return;
		}

		if (Number.isNaN(minValue)) {
			toast.warn(`Please set a value for Minimum ${props.x.filterFieldLabel}.`)
			return;
		}

		if (Number.isNaN(maxValue)) {
			toast.warn(`Please set a value for Maximum ${props.x.filterFieldLabel}.`)
			return;
		}

		if (minValue < 0 || maxValue < 0) {
			toast.warn(`Minimum and Maximum of ${props.x.filterFieldLabel} must be positive numbers.`)
			return;
		}

		if (minValue != null && maxValue != null) {
			if (minValue > maxValue) {
				toast.warn(`Minimum ${props.x.filterFieldLabel} value must be lower than Maximum ${props.x.filterFieldLabel} value.`)
				return;
			}
		}
		  // Generate query string
		  const queryParams = new URLSearchParams();  
		
		  if (minValue != null && maxValue != null) {
			queryParams.append(`min${props.x.filterField}`, `${minValue}`);
			queryParams.append(`max${props.x.filterField}`, `${maxValue}`);
		  }
	
		  // Convert query parameters to a string
		  const queryString = queryParams.toString();
		  
		  props.onFilterChange(queryString);	
	  	};

	return (
		<div className={styles.mainContainer}>
			<div className={styles.filterContainer}>
				<div className={styles.propertyName}>
					{props.x.filterFieldLabel}
				</div>
				<div className={styles.filterInline}>
					<div className={styles.container}>
						<div className={styles.inputContainer}>
							<input 
							className={styles.input} 
							type='number'
							onChange={(x) => setMinValueString(x.target.value)}
							value={minValueString}
							min={0}
							max={maxValueString}
							placeholder={props.x.unitPlaceholder}
							/>
						</div>
					</div>
					<div>-</div>
					<div className={styles.container}>
						<div className={styles.inputContainer}>
							<input 
							className={styles.input} 
							type='number'
							onChange={(x) => setMaxValueString(x.target.value)}
							value={maxValueString}
							min={minValueString}
							placeholder={props.x.unitPlaceholder}
							/>
						</div>
					</div>
					<button className={`standardButton ${styles.button}`} onClick={onComponentFilterChange}>
						Go
					</button>
				</div>
			</div>
		</div>
	);
};

export default RangeFilterComponent;
